import {
    useReducer,
} from 'react'
import {
    LaneQuoteViewType,
} from 'app/enums/label.enums'
import {
    ContactsSelection,
    PrintFilterValues, QUOTATION,
} from 'app/Apps/Pricing/ContractBasis/components/PrintFiltersForm/PrintForm.types'
import {
    PrintPreviewUniq,
    TypeWithId,
} from 'app/Apps/Pricing/ContractBasis/utils/createQuote.types'

const initialState = {
    additionalFee: undefined as TypeWithId,
    laneGroups: [] as TypeWithId[],
    laneFeesSelectedRows: [] as string[],
    additionFeesSelectedRows: [] as number[],
    filtersState: {
        customerType: QUOTATION,
        isCustomerQuotation: true,
    } as Partial<PrintFilterValues>,
    previewData: {
        additionalFeesTableRows: [],
        lanesTableRows: [],
        laneQuoteViewType: LaneQuoteViewType.DETAILED_VIEW,
    } as PrintPreviewUniq,
    contactsSelection: {} as ContactsSelection,
}

export type State = typeof initialState

type Action =
    | { type: 'SET_ADDITIONAL_FEE'; payload: TypeWithId | undefined }
    | { type: 'SET_LANE_GROUPS'; payload: TypeWithId[] | undefined }
    | { type: 'SET_LANE_FEES_SELECTED_ROWS'; payload: string[] }
    | { type: 'SET_ADDITION_FEES_SELECTED_ROWS'; payload: number[] }
    | { type: 'SET_FILTERS_STATE'; payload: Partial<PrintFilterValues> }
    | { type: 'SET_PREVIEW_DATA'; payload: PrintPreviewUniq }
    | { type: 'SET_CONTACTS_SELECTION'; payload: ContactsSelection }

const reducer = (state: State, action: Action): State => {
    switch (action.type) {
    case 'SET_ADDITIONAL_FEE':
        return {
            ...state, additionalFee: action.payload,
        }
    case 'SET_LANE_GROUPS':
        return {
            ...state, laneGroups: action.payload,
        }
    case 'SET_LANE_FEES_SELECTED_ROWS':
        return {
            ...state, laneFeesSelectedRows: action.payload,
        }
    case 'SET_ADDITION_FEES_SELECTED_ROWS':
        return {
            ...state, additionFeesSelectedRows: action.payload,
        }
    case 'SET_FILTERS_STATE':
        return {
            ...state, filtersState: action.payload,
        }
    case 'SET_PREVIEW_DATA':
        return {
            ...state, previewData: action.payload,
        }
    case 'SET_CONTACTS_SELECTION':
        return {
            ...state, contactsSelection: action.payload,
        }
    default:
        return state
    }
}

const useContractBasisCreateQuoteReducer = () => {
    const [
        state,
        dispatch,
    ] = useReducer(reducer, initialState)

    const setAdditionalFee = (payload: TypeWithId | undefined) => {
        dispatch({
            type: 'SET_ADDITIONAL_FEE', payload,
        })
    }

    const setLaneGroups = (payload: TypeWithId[] | undefined) => {
        dispatch({
            type: 'SET_LANE_GROUPS', payload,
        })
    }

    const setLaneFeesSelectedRows = (payload: string[]) => {
        dispatch({
            type: 'SET_LANE_FEES_SELECTED_ROWS', payload,
        })
    }

    const setAdditionFeesSelectedRows = (payload: number[]) => {
        dispatch({
            type: 'SET_ADDITION_FEES_SELECTED_ROWS', payload,
        })
    }

    const setFiltersState = (payload: Partial<PrintFilterValues>) => {
        dispatch({
            type: 'SET_FILTERS_STATE', payload,
        })
    }

    const setPreviewData = (payload: PrintPreviewUniq) => {
        dispatch({
            type: 'SET_PREVIEW_DATA', payload,
        })
    }

    const setContactsSelection = (payload: ContactsSelection) => {
        dispatch({
            type: 'SET_CONTACTS_SELECTION', payload,
        })
    }

    return {
        state,
        setAdditionalFee,
        setLaneGroups,
        setLaneFeesSelectedRows,
        setAdditionFeesSelectedRows,
        setFiltersState,
        setPreviewData,
        setContactsSelection,
    }
}

export default useContractBasisCreateQuoteReducer
